:host {
    display: block;
}

.pages {
    position: relative;
    overflow: hidden;
    height: 100%;
    transition-property: min-height;
    transition-duration: 500ms;
    transition-timing-function: ease;
}

.animating .page {
    display: block;
}

.page {
    top: 0;
    position: absolute;
    z-index: -1;
    width: 100%;
    opacity: 0;
    transition-property: transform, opacity;
    transition-duration: 500ms;
    transition-timing-function: ease;
    transform: translateX(0%);
    background-color: var(--color-background);
    display: none;
}

.page.passed {
        pointer-events: none;
    }

.page.future {
        pointer-events: none;
        transform: translateX(5%);
    }

.page.active {
        position: relative;
        opacity: 1;
        z-index: 1;
        display: block;
    }
